import { Tab, Tabs } from '@mui/material';
import React from 'react';
import { useTheme } from '../../hooks/useTheme';

type CustomTabsProps = {
    selectedTab: number;
    handleTabChange: (event: React.SyntheticEvent, newValue: number) => void;
    tabLabels: string[];
};

const CustomTabs: React.FC<CustomTabsProps> = ({ selectedTab, handleTabChange, tabLabels }) => {
    const { muiTheme } = useTheme();

    return (
        <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons={false}
            allowScrollButtonsMobile
            sx={{
                borderBottom: 1,
                borderColor: muiTheme.palette.divider,
            }}
        >
            {tabLabels.map((tab, index) => (
                <Tab label={tab} key={index} />
            ))}
        </Tabs>
    );
};

export default CustomTabs;
